import React, {useEffect} from 'react';
import IntroForm from "../containers/IntroForm";
import {withRouter} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {makeStyles} from "@material-ui/core/styles";
import client from "../lib/api/client";
import {setSurveyData} from "../modules/survey";
import {setMenuData} from "../modules/menu";
import {loadAnswer} from "../modules/answers";
import {loadFamily} from "../modules/family";
import {useDispatch, useSelector, useStore} from "react-redux";
import {setAgreeData} from "../modules/agree";
import {setCorprInfo, setUserInfo} from "../modules/user";
import {setCommercialData, setHouseData} from "../modules/rent";
import {store} from "react-notifications-component";

const useStyles = makeStyles(theme => ({
    layout: {
        display: 'block',
        width: 'auto',
        maxWidth: '100%'
    },
    paper: {
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        background: 'transparent',
        boxShadow: 'none'
    },
    title: {
        flexGrow: 1,
    },
    loadingSpinner: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        marginLeft: '-50px',
        marginTop: '-50px',
        zIndex: 999
    },
}));

const IntroPage = ({login, isTmpCont, history}) => {
    const classes = useStyles();

    useEffect(() => {

        // const agent = window.navigator.userAgent.toLowerCase();

        // IE 체크
        // if (agent.indexOf("trident") > -1) {
        //     store.addNotification({
        //         title: "알림",
        //         message: "IE에서는 정상적으로 동작하지 않습니다. 권장 브라우저(크롬, 엣지)를 이용해 주시기 바랍니다.",
        //         type: 'danger',
        //         insert: "top",
        //         container: "top-center",
        //         animationIn: ["animated", "flipInY"],
        //         animationOut: ["animated", "flipOutY"],
        //         dismiss: {
        //             duration: 1000 * 60,
        //             onScreen: false
        //         },
        //         width: 500
        //     });
        // }

        // if (login) {
        //     // 임시저장 데이터 존재하면 로드
        //     if (isTmpCont) {
        //         const CORPR = JSON.parse(localStorage.getItem("CORPR_BASE_INFO"));
        //         dispatch(setCorprInfo(CORPR));
        //
        //         const {
        //            stdYear,
        //            corprInfoDiviNo,
        //            userId
        //         } = userInfo;
        //
        //         client.post('/api/load/tmp', { stdYear, corprInfoDiviNo, userId }).then(response => {
        //             const storeData = JSON.parse(response.data.STORE_DATA);
        //             dispatch(setAgreeData(storeData.agree.agree));
        //             dispatch(setSurveyData(storeData.survey.survey));
        //             dispatch(setMenuData(storeData.menu.menu));
        //             dispatch(loadAnswer(storeData.answers));
        //             dispatch(loadFamily(storeData.family));
        //             if (Object.keys(storeData.rent.house).length > 0) {
        //                 const tmpArray = Object.keys(storeData.rent.house).map((item) => storeData.rent.house[item]);
        //                 dispatch(setHouseData(tmpArray));
        //             }
        //             if (Object.keys(storeData.rent.commercial).length > 0) {
        //                 const tmpArray = Object.keys(storeData.rent.house).map((item) => storeData.rent.commercial[item]);
        //                 dispatch(setCommercialData(tmpArray));
        //             }
        //
        //             history.push("/agree");
        //         }).catch((error) => {
        //             console.log(error);
        //         });
        //     } else {
        //         if (userInfo && userInfo.surveyYn === "1") {
        //             history.push("/result");
        //         } else {
        //             history.push("/agree");
        //         }
        //
        //     }
        // }
    }, []);

    return (
        <>
            <Grid container
                  style={{
                      margin: 0,
                      width: '100%',
                      height: '100%',
                      background: '#f1ece2'
                  }}>
                <Grid container
                      spacing={0}
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                      className='intro-container'
                >
                    <div className={classes.layout}>
                        <Paper className={classes.paper}>
                            <IntroForm stdYear={"2025"}/>
                        </Paper>
                    </div>
                </Grid>
            </Grid>
        </>
    )
};

export default withRouter(IntroPage);
